import CommonCRUD from "modules/CommonCRUD";

class Customers extends CommonCRUD {
    api = undefined;

    schema = "customers";

    constructor(api) {
        super(api);
        this.api = api;
    }

    async changeAdmin({ customer_id, user_id }) {
        const { customer } = await this.api.fetch({
            method: "post",
            url: `/${this.schema}/${customer_id}/change_admin`,
            data: {
                user_id,
            },
        });
        return customer;
    }

    async getUsers(customer_id, name = "", id = "") {
        const res = await this.api.fetch({
            returnBody: true,
            method: "post",
            url: `/${this.schema}/${customer_id}/users`,
            ...(name
                ? {
                      data: {
                          name,
                      },
                  }
                : id
                  ? {
                        data: {
                            id,
                        },
                    }
                  : {}),
        });
        return res;
    }

    async uploadTariffInfo(customer_id, base64) {
        return await this.api.fetch({
            method: "post",
            url: `/${this.schema}/${customer_id}/tariff-info`,
            data: {
                "tariff-info": base64,
            },
        });
    }

    async deleteTariffInfo(customer_id) {
        return await this.api.fetch({
            method: "delete",
            url: `/${this.schema}/${customer_id}/tariff-info`,
        });
    }
}

export default Customers;
